define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-games-content';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentHeaderCls, 'animate__slideInDown', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentDescriptionFirstCls, 'animate__fadeIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentDescriptionYtCls, 'animate__fadeIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameBoxWrapperCls + '1', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameBoxWrapperCls + '2', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameBoxWrapperCls + '3', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameBoxWrapperCls + '4', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentMoleyButtonWrapperCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentDescriptionSecondCls, 'animate__fadeIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentVideoFrameGamesCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentVideoFrameYtCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameSmallBoxWrapperCls + '1', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameSmallBoxWrapperCls + '2', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameSmallBoxWrapperCls + '3', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentGameSmallBoxWrapperCls + '4', 'animate__flipInY', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentCharactersLeftCls, 'animate__fadeIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentCharactersRightCls, 'animate__fadeIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentCharactersCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentRobloxButtonWrapperCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSubheaderGamesCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSpacerGamesCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSubheaderYtCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSpacerYtCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentYtLogoWrapperCls, 'animate__rotateIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSubheaderSocialCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentSpacerSocialCls, 'animate__zoomIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentDescriptionSocialCls, 'animate__fadeIn', 'games-content', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentFbLogoWrapperCls, 'animate__rotateIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentTwLogoWrapperCls, 'animate__rotateIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentTikTokLogoWrapperCls, 'animate__rotateIn', 'games-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.gamesContentInstagramLogoWrapperCls, 'animate__rotateIn', 'games-content', {});

            };

            view.bind = function () {

            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });